import { render, staticRenderFns } from "./App.vue?vue&type=template&id=ef7f51e8"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=ef7f51e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_310753db291b809859cbd9e654a8ef6f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports